import React,{Component} from 'react';
import {createMarkup} from './Factory';
import Flexbox from '../components/misc/Flexbox'; 
import PressImage from '../components/PressImage'; 
import Masonry from 'react-masonry-component';
import downloadicon from '../images/download.svg';
import downloadiconblack from '../images/download-black.svg';

class PresseAustellungen extends Component {
    constructor(props) {
		super(props);
		this.state = { 
			cycle:''
		}
	}
	handlePrevious(id){
		let image_id = "image_id_"+Number(id-1);
		let imageElement = document.getElementById(image_id)
		if (imageElement) 
			imageElement.click();
	}
	handleNext(id){
		let image_id = "image_id_"+Number(id+1);
		let imageElement = document.getElementById(image_id)
		if (imageElement) 
			imageElement.click();
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	 
		setTimeout(function(){
			document.getElementById('submenu-ausstellungen').classList.add('active');
			document.getElementById('menu-presse').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('submenu-ausstellungen').classList.remove('active');
		document.getElementById('menu-presse').classList.remove('active');	
	}
	render(){				
		const { 
			title,exhibition_start_date_final,exhibition_end_date_final,featured,label_pressmappe,
			download_text,press_file,press_label,pressemappe,press_image,press_image_heading,press_image_text,press_image_small	
		} = this.props;	 
		
		return(
			<div className="col-md-12">
				<div className="row">
					<article className="col-md-8 article-full">
						<h1 dangerouslySetInnerHTML={createMarkup(title)}></h1>
						 <div className="times">
							<time dateTime={exhibition_start_date_final}>{exhibition_start_date_final} </time>
							<time dateTime={exhibition_end_date_final}>{'\u00A0'}– {exhibition_end_date_final}</time>
						 </div>			
						<img alt={title} src={featured} />
					</article>
					{
					(pressemappe || press_file) ?
					<aside className="col-md-4 sidebar article-list">				
						<div className="press-material txt-block sidebar-block">
							<Flexbox left="Down" right="loads" />
							<p dangerouslySetInnerHTML={createMarkup(download_text)}></p>
							{
							(pressemappe) ?
								<a href={pressemappe} target="_blank" className="btn dark-btn margin-top-30 margin-top-10-tablet margin-top-10-mobile">
									{label_pressmappe}
									<img src={downloadicon} alt="download" />
								</a>
							:null
							}
							{
							(press_file)?
								<ul className="margin-top-20 press_downloads">
									{
									press_label.map( (data,i)=>
										<li key={i} >
											<a target="_blank" href={press_file[i]} >
												{data}	
												<img className="download_icon" src={downloadiconblack} alt="download" />
											</a>	
										</li>
										)
									}	
								</ul>
							:null
							}
						</div>
					</aside>				
					:null
					}
				</div>	
				{
				(press_image)?	
					<div className="row">
						<div className="col-md-12">
							<div className="row">
								<Masonry updateOnEachImageLoad={true} className="press_image_gallery">
									{														
										press_image.map( (data,i)=>
											<PressImage 
													handleNext={this.handleNext}
													handlePrevious={this.handlePrevious}
													key={i} id={i} image_small={press_image_small[i]} image={data} heading={press_image_heading[i]} desc={press_image_text[i]} />
										)	
									}
								</Masonry>
							</div>
						</div>
					</div>
				:null
				}
			</div>
				
		)
	}
}
export default PresseAustellungen; 


// WEBPACK FOOTER //
// ./src/components/PresseAustellungen.js